import React from 'react';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { makeStyles } from '@material-ui/core/styles';
import { PlaystoreLogo, AppstoreLogo } from './logo';
import { useHistory } from 'react-router-dom';
import Logo from '../assets/broSolat.png';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: 30,

  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

const Footer = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <div style={{ padding: 20, marginTop: 30, backgroundColor: '#e6e6e6', borderRadius: 15 }}>

        <Grid container spacing={1} >

          <Grid item xs={12} sm={6}>
            <div style={{ display: 'flex', flexDirection: 'row', marginTop: 20 }}>
              <img src={Logo} width={50} height={50} style={{ borderRadius: 10, marginRight: 10 }} onClick={() => history.push('/')} />
              <h4 style={{ fontFamily: 'Futura' }}>BroSolat</h4>
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <MailOutlineIcon fontSize={'default'} color={'inherit'} />
              <p style={{ marginBottom: 15, marginLeft: 5 }}>mohamedariff.abdrahim@gmail.com</p>
            </div>
          </Grid>

          <Grid item xs={12} sm={6} >
            <p style={{ fontFamily: 'Futura', margin: 20 }}>Download now</p>
            {/* <PlaystoreLogo width={100} height={30} style={{ margin: 10 }} /> */}
            <AppstoreLogo width={100} height={30} style={{ margin: 10 }} href={`https://apps.apple.com/us/app/bro-solat/id1490261953`} />
          </Grid>
          <p style={{ fontSize: 11 }}>Image background by
        <a style={{ fontSize: 11 }} href={'https://unsplash.com/@aliarifsoydas'} target='blank'>
              <b> Ali Arif Soydaş on Unsplash</b>
            </a>
          </p>
        </Grid>
      </div>

    </div>
  )
}

export default Footer